import mitt from "mitt";

const eventBus = mitt();

export default eventBus; // ✅ Use default export
